/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IUser = Models.IUser;
    import IUserGroup = Models.IUserGroup;

    export interface IUserRouteParamsService  extends ng.route.IRouteParamsService {
        usernameOrId: string | number;
    }

    declare function isNaN(value: number | string): boolean;

    /**
     * DashboardController class
     */
    export class AdminUserController {
        public static $name: string = "adminUserController";
        public static $inject: string[] = ['userService',
                                           'userGroupService',
                                           '$routeParams',
                                           '$timeout',
                                           'ModalService',
                                           '$scope',
                                           'vnoService',
                                           ];

        public user: IUser;
        public isAdmin: boolean;
        public userGroups: IUserGroup[];

        private userService: Services.UserService;
        private userGroupService: Services.UserGroupService;
        private $routeParams: IUserRouteParamsService;
        private $timeout: ng.ITimeoutService;
        private modalService: ngModal.IModalService;
        private $scope: ng.IScope;
        private vnoService: Services.VnoService;
        private allUserGroups: IUserGroup[];

        /**
         * Constructor
         */
        constructor(userService: Services.UserService,
                    userGroupService: Services.UserGroupService,
                    $routeParams: IUserRouteParamsService,
                    $timeout: ng.ITimeoutService,
                    modalService: ngModal.IModalService,
                    $scope: ng.IScope,
                    vnoService: Services.VnoService,
                    ) {
            this.userService = userService;
            this.userGroupService = userGroupService;
            this.$routeParams = $routeParams;
            this.$timeout = $timeout;
            this.modalService = modalService;
            this.$scope = $scope;
            this.vnoService = vnoService;
            if (this.$routeParams.usernameOrId &&
                (this.$routeParams.usernameOrId as number > 0 || this.$routeParams.usernameOrId as string !== '')) {
                this.userService.findByUsername(this.$routeParams.usernameOrId as string)
                    .then((response: IUser) => {
                        if (response) {
                            this.user = response;
                            this.vnoService.isAdminUser(+response.id).then((isAdmin: boolean) => {
                                this.isAdmin = isAdmin
                                this.initAdminWatch();
                            });
                            this.getUserGroups();
                            this.getAllUserGroups();
                        }
                    });
            }
        }

        public saveUser(user?: IUser): void {
            let userToSave: IUser = user ? user : this.user;
            this.userService.saveUser(userToSave)
                .then((response: IUser) => {
                    this.user = response;
                    this.getUserGroups();
                }).catch((reason: ngCustom.IReason) => {
                    this.modalService.showModal({
                        templateUrl: Controllers.ErrorModalController.templateURL,
                        controller: Controllers.ErrorModalController.$name,
                        inputs: {
                            title: 'Error saving user',
                            description: reason.data.message,
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ErrorModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then((result: Object) => {
                            modalElem.hide();
                        });
                    });
                });
        }

        public launchUserModal(): void {
            let copy: IUser = Models.User.createCopy(this.user);
            // Remove password to not show it in the modal
            copy.password = undefined;
            this.modalService.showModal({
                templateUrl: Controllers.UserNewEditModalController.templateURL,
                controller: Controllers.UserNewEditModalController.$name,
                inputs: {
                    title: 'Edit user',
                    user: copy,
                    vnos: undefined,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.UserNewEditModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result?: IUserEditResponse) => {
                    modalElem.hide();
                    if (result)
                        this.saveUser(result.user);
                });
            });
        }

        public launchGroupsListModal(): void {
            let availableUserGroups: IUserGroup[] = this.allUserGroups;
            this.userGroups.forEach((userGroup: IUserGroup) => {
                availableUserGroups = availableUserGroups.filter((group: IUserGroup) => {
                    return group.id !== userGroup.id;
                });
            });
            if (availableUserGroups.length > 0) {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.AdminGroupsListModalController.templateURL,
                    controller: Application.Controllers.AdminGroupsListModalController.$name,
                    inputs: {
                        username: this.user.username,
                        groups: availableUserGroups,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AdminGroupsListModalController.ID, 
                                                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result?: number) => {
                        modalElem.hide();
                        if (result) {
                            this.addUserToGroup(result);
                        }
                    });
                });
            } else {
                Common.Utils.alertOnInfo('There are no more groups to add!');
            }
        }

        public addUserToGroup(groupId: number): void {
            this.userGroupService
                .addUserToGroup(this.user.id as number, groupId, this.user.organizationId)
                .then((response: IUser) => {
                    this.user = response;
                    this.getUserGroups();
                });
        }

        public removeUserFromGroup(groupId: number): void {
            this.userGroupService
                .removeUserFromGroup(groupId, this.user.id as number)
                .then((response: IUser) => {
                    this.user = response;
                    this.getUserGroups();
                });
        }

        public toggleUserEnabled(): void {
            this.user.enabled = !this.user.enabled;
            this.saveUser();
        }

        public loginAsUser(): void {
            Common.Utils.alertOnInfo('Coming soon!');
        }

        public resetPassword(): void {
            Common.Utils.alertOnInfo('Coming soon!');
        }

        public launchAvatarModal(user: IUser): void {
            let copy: IUser = Models.User.createCopy(user);
            this.modalService.showModal({
                templateUrl: Application.Controllers.AvatarModalController.templateURL,
                controller: Application.Controllers.AvatarModalController.$name,
                inputs: {
                    user: copy,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AvatarModalController.ID, 
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result?: Models.IUser) => {
                    modalElem.hide();
                    if (result) {
                        this.userService
                            .saveUser(result)
                            .then((response: Models.IUser) => {
                                this.user = response;
                            });
                    }
                });
            });
        }

        private getUserGroups(): void {
            this.userGroupService
                .findByUserId(this.user.id as number)
                .then((response: IUserGroup[]) => {
                    this.userGroups = response;
                });
        }

        private getAllUserGroups(): void {
            this.userGroupService
                .findAll()
                .then((response: IUserGroup[]) => {
                    this.allUserGroups = response;
            });
        }

        private initAdminWatch(): void {
            this.$scope.$watch('auc.isAdmin', (newValue: boolean, oldValue: boolean) => {
                if (newValue !== oldValue) {
                    if (newValue) {
                        this.userService.addRoleToUser(this.user, "ROLE_ADMIN").then(() => {
                            Common.Utils.alertOnSuccess("Role Admin assigned to user");
                        });
                    } else {
                        this.userService.deleteRoleFromUser(this.user, "ROLE_ADMIN").then(() => {
                            Common.Utils.alertOnSuccess("Role Admin removed from user");
                        });
                    }
                }
            });
        }
    }
}
